var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5998 15.4H12.7998V26H17.5998V15.4Z",
    fill: "#00ADEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9001 10.1H4.1001V26H8.9001V10.1Z",
    fill: "#00ADEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 3.8H21.5V26H26.3V3.8Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarActive);
export default __webpack_public_path__ + "static/media/bar-active.8a02578330f3bd63c8832571e5c6629c.svg";
export { ForwardRef as ReactComponent };